import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth'
import { AIProvidersPage } from '@/features/ai-providers'

export const Route = createFileRoute('/_authenticated/admin/ai-providers/')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user?.role !== 'admin' && auth.user?.role !== 'super_admin') {
      throw redirect({ to: '/403' })
    }
  },
  component: AIProvidersPage,
})
